var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFoldertwo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 22,
    viewBox: "0 0 35 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.09055,
    width: 25.4406,
    height: 21.1256,
    rx: 1.43834,
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.60883,
    y: 1.50635,
    width: 23.4592,
    height: 14.8503,
    rx: 1.43834,
    fill: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.64034 3.97425C0.898122 2.17609 0.527013 1.277 0.954217 0.638502C1.38142 0 2.35408 0 4.29941 0H23.5159C24.4486 0 24.915 0 25.278 0.242898C25.6411 0.485796 25.819 0.916901 26.1749 1.77911L32.5201 17.1514C33.2623 18.9495 33.6334 19.8486 33.2062 20.4871C32.779 21.1256 31.8063 21.1256 29.861 21.1256H10.6446C9.71179 21.1256 9.2454 21.1256 8.88236 20.8827C8.51933 20.6398 8.34138 20.2087 7.98549 19.3465L1.64034 3.97425Z",
    fill: "#EEEEEE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoldertwo);
export default __webpack_public_path__ + "static/media/foldertwo.3d34c959b51aea6d66ec309ed4a33049.svg";
export { ForwardRef as ReactComponent };